var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidenavHideIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 22,
    viewBox: "0 0 32 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.62849 21.0238H28.7713C29.3776 21.0238 29.9589 20.783 30.3876 20.3544C30.8162 19.9257 31.0571 19.3443 31.0571 18.7381V3.78571C31.0571 3.17951 30.8162 2.59812 30.3876 2.16947C29.9589 1.74082 29.3776 1.5 28.7713 1.5H3.62849C3.02228 1.5 2.4409 1.74082 2.01224 2.16947C1.58359 2.59812 1.34277 3.17951 1.34277 3.78571L1.34277 18.7381C1.34277 19.3443 1.58359 19.9257 2.01224 20.3544C2.4409 20.783 3.02228 21.0238 3.62849 21.0238Z",
    stroke: "#393939",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2002 1.69141V21.0247",
    stroke: "#393939",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3027 15.1264L13.5335 11.3571L17.3027 7.58789",
    stroke: "#393939",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5332 11.3574H27.5332",
    stroke: "#393939",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidenavHideIcon);
export default __webpack_public_path__ + "static/media/sidenav-hide-icon.1beffe717e4a3fb4f0e6dccf8f0cd8f3.svg";
export { ForwardRef as ReactComponent };